import { Box, ButtonGroup, ButtonVariants, FormControlSizes, ToggleButton } from '@talos/kyoko';
import type { PriceGridFilterState } from '../types';
import {
  GENERIC_PRICE_GRID_PRODUCT_TYPE_OPTIONS,
  GENERIC_PRICE_GRID_PRODUCT_TYPES,
  type PriceGridProductType,
} from './options';

interface PriceGridProductTypeFilterProps {
  filterState: PriceGridFilterState;
  onFilterStateChanged: (filterState: PriceGridFilterState) => void;
}

export function PriceGridProductTypeFilter({ filterState, onFilterStateChanged }: PriceGridProductTypeFilterProps) {
  const selectedProductTypes = filterState.productTypes ?? [];

  const handleProductTypeToggled = (productType: PriceGridProductType) => {
    const selectedProductTypesSet = new Set(selectedProductTypes);
    if (selectedProductTypesSet.has(productType)) {
      selectedProductTypesSet.delete(productType);
    } else {
      selectedProductTypesSet.add(productType);
    }

    const nextProductTypes = GENERIC_PRICE_GRID_PRODUCT_TYPES.filter(value => selectedProductTypesSet.has(value));
    onFilterStateChanged({
      ...filterState,
      productTypes: nextProductTypes.length === 0 ? undefined : nextProductTypes,
    });
  };

  return (
    <Box display="flex" alignItems="center" alignSelf="center">
      <ButtonGroup size={FormControlSizes.Small}>
        {GENERIC_PRICE_GRID_PRODUCT_TYPE_OPTIONS.map(({ productType, label }) => {
          const selected = selectedProductTypes.includes(productType);
          return (
            <ToggleButton
              key={productType}
              grouped
              selected={selected}
              selectedVariant={ButtonVariants.Priority}
              unselectedVariant={ButtonVariants.Default}
              size={FormControlSizes.Small}
              onClick={() => handleProductTypeToggled(productType)}
            >
              {label}
            </ToggleButton>
          );
        })}
      </ButtonGroup>
    </Box>
  );
}
